"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageSettings = void 0;

var getLanguageSettings = function getLanguageSettings(state) {
  return state.modules.marketing.domains.entities.languageSettings;
};

exports.getLanguageSettings = getLanguageSettings;